var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0028 32.6853C60.0028 30.3831 59.8121 28.7031 59.3996 26.9609H32.5742V37.3519H48.3201C48.0028 39.9342 46.2885 43.8231 42.4789 46.4363L42.4255 46.7842L50.9072 53.2235L51.4948 53.2809C56.8915 48.3964 60.0028 41.2097 60.0028 32.6853",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5725 60.064C40.2866 60.064 46.7627 57.575 51.493 53.2817L42.4771 46.437C40.0645 48.086 36.8263 49.2371 32.5725 49.2371C25.017 49.2371 18.6044 44.3527 16.3185 37.6016L15.9834 37.6294L7.16404 44.3184L7.04871 44.6326C11.7471 53.7793 21.3978 60.064 32.5725 60.064Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3201 37.6024C15.717 35.8602 15.3679 33.9934 15.3679 32.0646C15.3679 30.1356 15.717 28.269 16.2884 26.5268L16.2724 26.1557L7.34252 19.3594L7.05035 19.4956C5.11393 23.2912 4.00281 27.5535 4.00281 32.0646C4.00281 36.5757 5.11393 40.8378 7.05035 44.6334L16.3201 37.6024",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5726 14.8891C37.9376 14.8891 41.5566 17.1602 43.6202 19.0581L51.6837 11.3425C46.7314 6.8314 40.2868 4.0625 32.5726 4.0625C21.3979 4.0625 11.7471 10.3469 7.04871 19.4935L16.2868 26.5247C18.6045 19.7736 25.0171 14.8891 32.5726 14.8891",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7c2beee7c5a0591aa020be6dbfcdd925.svg";
export { ForwardRef as ReactComponent };